import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "placeholder", "tooltip", "tooltipAbsolute", "theme", "disabled", "error", "invalid", "onChange", "onFocus", "onBlur", "classes", "namespace", "tooltipProps", "success", "name", "textAreaProps"];
import React, { forwardRef, useRef } from 'react';
import classNames from 'classnames/bind';
import { useCombinedRefs } from "../hooks";
import { FieldRoot, useField } from "../internal/Field";
import styles from './TextArea.css';
var cx = classNames.bind(styles);
var TextArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      tooltip = _ref.tooltip,
      tooltipAbsolute = _ref.tooltipAbsolute,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      disabled = _ref.disabled,
      error = _ref.error,
      invalid = _ref.invalid,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      classes = _ref.classes,
      namespace = _ref.namespace,
      tooltipProps = _ref.tooltipProps,
      success = _ref.success,
      name = _ref.name,
      textAreaProps = _ref.textAreaProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var inputRef = useRef(null);
  var combinedRef = useCombinedRefs(inputRef, textAreaProps === null || textAreaProps === void 0 ? void 0 : textAreaProps.ref);

  var _useField = useField({
    onBlur: onBlur,
    onFocus: onFocus,
    ref: textAreaProps === null || textAreaProps === void 0 ? void 0 : textAreaProps.ref,
    componentName: 'textArea',
    namespace: namespace
  }),
      focused = _useField.focused,
      handleBlur = _useField.handleBlur,
      handleFocus = _useField.handleFocus,
      getNamespace = _useField.getNamespace,
      getTestId = _useField.getTestId,
      isAutofill = _useField.isAutofill;

  return /*#__PURE__*/React.createElement(FieldRoot, _extends({}, props, {
    ref: ref,
    disabled: disabled,
    focused: focused,
    invalid: invalid || error,
    success: success,
    theme: theme,
    tooltip: tooltip,
    tooltipAbsolute: tooltipAbsolute,
    tooltipProps: tooltipProps,
    autofill: isAutofill,
    namespace: getNamespace(),
    classes: {
      root: classes === null || classes === void 0 ? void 0 : classes.root,
      container: cx('container', classes === null || classes === void 0 ? void 0 : classes.container)
    }
  }), /*#__PURE__*/React.createElement("textarea", _extends({}, textAreaProps, getTestId('input'), {
    ref: combinedRef,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: onChange,
    value: value,
    placeholder: placeholder,
    name: name,
    className: cx('textarea', classes === null || classes === void 0 ? void 0 : classes.textarea),
    disabled: disabled
  })));
});
export default TextArea;